<template>
  <div id="app">
    <!--<transition :name="transitionName" appear>-->
        <keep-alive name="keep-alive">
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!--<app-footer id="footer"></app-footer>-->
    <!--</transition>-->
    <wx-loading :show="showLoadingPic" :loadingText="$t('lang.loadingText')"></wx-loading>
  </div>
</template>

<script>
import { isArd, isiOS, isMideaConnect, isPC, getCookie } from './utils/utils'
import { mapGetters } from 'vuex'
import platform from './platform'
import wxLoading from './components/wxLoading/index.vue'
export default {
  name: 'App',
  components: {
    wxLoading
  },
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    showLoadingPic () {
      return this.$store.getters.showLoadingPic
    },
    ...mapGetters(['closeGallery'])
  },
  watch: {
    closeGallery (val) {
      if (val) {
        this.$previewClose()
        this.$store.commit('SET_CLOSE_GALLERY', false)
      }
    }
  },
  methods: {
    getLanguage () {
      if (isPC()) {
        this.flag = true
      }
      // 新增语言判断
      let lang = ''
      const isHM= navigator.userAgent.indexOf('OpenHarmony') > -1;
      console.log('多语言判断isMideaConnect',isMideaConnect(),isPC(),isArd(),window.navigator.language,isHM,navigator.userAgent)

      if (isMideaConnect() && !isHM) {
        if (isArd()) {
          // lang = window.navigator.language.split('-')[0]
          const self = this
          document.addEventListener('deviceready', function () {
            platform.language().then(res => {
              const l = res.language.split('_')[0]
              if (l === 'cn') {
                self.$i18n.locale = 'zh'
              } else {
                self.$i18n.locale = l
              }
            })
          }, false)
        } else if (isiOS()) {
          const temp = window.navigator.userAgent.match(/\/(en|ja|zh-Hans)\//g)
          if (temp[0] === '/en/') {
            lang = 'en'
          } else if (temp[0] === '/ja/') {
            lang = 'ja'
          } else {
            lang = 'zh'
          }
        }else if (isPC()) {
          console.log('pc模式',this.$route.query.locale)
          if (this.$route.query.locale === 'cn_ZH') {
            lang = 'zh'
          } else {
            // 判断是否存在语言参数
            if (typeof this.$route.query.locale !== 'undefined') {
              lang = this.$route.query.locale.split('_')[0]
            } else {
              const pcLang = getCookie('language')
              if (pcLang === 'zh-CN' || !pcLang) {
                lang = 'zh'
              } else {
                lang = pcLang
              }
            }
          }
        }
      }else if(isHM){
        const self = this
          document.addEventListener('deviceready', function () {
            platform.language().then(res => {
              console.log('鸿蒙=',res)
              const l = res.language.split('_')[0]
              if (l === 'cn') {
                self.$i18n.locale = 'zh'
              } else if(l === 'jp'){
                self.$i18n.locale = 'ja'
              }else {
                self.$i18n.locale = l
              }
            })
          }, false)
      } else {
        const language = window.navigator.language
        console.log('语言--',language)
        if (language === 'ja_JP') {
          lang = 'ja'
        } else if (language === 'en_US') {
          lang = 'en'
        } else {
          lang = 'zh'
        }
      }
      if (!(isMideaConnect() && (isHM || isArd()))) {
        this.$i18n.locale = lang
      }
      // this.$i18n.locale = 'en'
    },
    handleLinkClick(event){
      // debugger;
        event.preventDefault();
        event.stopPropagation();
        const link = event.target;
        const url = link.href;
        link.setAttribute('href', 'javascript:void(0);');
        window.open(url, '_blank');
        setTimeout(() => {
          link.setAttribute('href', url);
        }, 1000);
    },
    addLinkListeners() {
      if(!isPC() && !isiOS()) return
      this.$nextTick(() => {
        const links = this.$el.querySelectorAll('a[target="_blank"]');
        links.forEach(link => {
          link.addEventListener('click', this.handleLinkClick);
        });
      });
    },
    removeLinkListeners() {
      if(!isPC() && !isiOS()) return
      const links = this.$el.querySelectorAll('a[target="_blank"]');
      links.forEach(link => {
        link.removeEventListener('click', this.handleLinkClick);
      });
    },
  },
  // watch: {
  //   $route: {
  //     handler(to, from) {
  //       to = to || {}
  //       from = from || {}
  //       let goTo
  //       if (from.path === '/') goTo = true
  //       let noAnimatePages = {
  //           // 从下列页面跳转到其它页面都没有转场动画 eg:['/initial']
  //           from: [],
  //           // 跳转到下列页面都没有转场动画 eg:['/initial']
  //           to: [],
  //           // 同时满足to和from时没有转场动画 eg:[{to:'/message/detail', from:'/'}]
  //           and: []
  //         };
  //       if (
  //         noAnimatePages.to.indexOf(to.path) > -1 ||
  //         noAnimatePages.from.indexOf(from.path) > -1
  //       ) {
  //         this.noAnimate = true;
  //       } else if (
  //         noAnimatePages.and.find(
  //           item => item.to === to.path && item.from === from.path
  //         )
  //       ) {
  //         this.noAnimate = true;
  //       } else {
  //         this.noAnimate = this.$router.noAnimate || false;
  //       }
  //       if (!this.noAnimate) {
  //         // 判断页面回退还是前进
  //         if (goTo) {
  //           this.transitionName = "slide-right";
  //         } else {
  //           this.transitionName = "slide-left";
  //         }
  //       } else {
  //         this.transitionName = "no-animate";
  //       }
  //       window.scrollTo(0, 0);
  //       this.$router.goTo = false;
  //       this.$router.noAnimate = false;
  //     },
  //     immediate: true
  //   }
  // },
  created () {
    this.$watch(
      () => this.$route.query.id,
      (newId, oldId) => {
        if (oldId && newId !== oldId) {
          // id 参数发生了改变
          console.log('id切换', newId, oldId)
          location.reload();
          // console.log("id has changed to " + newId);
        }
      }
    );
    // if (window.userId && window.token) {
    //   this.$store.dispatch('setUserId', window.userId)
    //   this.$store.dispatch('setToken', window.token)
    // }
    this.getLanguage()
  },
  mounted() {
    this.addLinkListeners();
  },
  updated() {
    this.addLinkListeners();
  },
  beforeDestroy() {
    this.removeLinkListeners();
  },
}
</script>
<style>
#app {
  /*font-family: Helvetica Neue,Helvetica,Arial,sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*width: 100vw;*/
  /*height: 100vh;*/
  /*overflow-y: scroll;*/
  /*overflow-x: hidden;*/

  -webkit-overflow-scrolling:touch;
}
 .overscroll {
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling:touch;
  }

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform .3s ease;
}
.slide-left-enter,
.slide-right-leave-active {
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  opacity: 0;
}
.slide-left-leave-active,
.slide-right-enter {
  -webkit-transform: translateX(50%);
  transform: translateX(50%);
  opacity: 0;
}
</style>
